module.exports = __webpack_public_path__ + "static/media/pa.b6f6c58d.svg";